import { Box, Divider, Typography } from "@mui/material";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import FormTextField from "../../components/forms/FormTextField";

const validationSchema = Yup.object({
  name: Yup.string()
    .required("Name is required")
    .min(3, "Name must be at least 3 characters"),
  email: Yup.string()
    .email("Invalid email address")
    .required("Email is required"),
  description: Yup.string(),
});

const FormTextFieldDemo = () => {
  const initialValues = {
    name: "",
    email: "",
    description: "",
  };

  return (
    <Box display="flex" flexDirection="column" gap={3}>
      <Typography variant="subtitle2">Basic FormTextField:</Typography>
      <Box maxWidth={400}>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={(values) => {
            console.log("Form submitted:", values);
          }}
        >
          <Form>
            <Box display="flex" flexDirection="column" gap={2}>
              <FormTextField label="Name" fieldName="name" required />
              <FormTextField
                label="Email"
                fieldName="email"
                type="email"
                required
              />
              <FormTextField
                label="Description"
                fieldName="description"
                helperText="Optional description field"
              />
            </Box>
          </Form>
        </Formik>
      </Box>

      <Divider />

      <Typography variant="subtitle2">With Helper Text:</Typography>
      <Box maxWidth={400}>
        <Formik initialValues={{ username: "" }} onSubmit={() => {}}>
          <Form>
            <FormTextField
              label="Username"
              fieldName="username"
              helperText="Choose a unique username"
            />
          </Form>
        </Formik>
      </Box>

      <Divider />

      <Typography variant="subtitle2">
        Error State (Touch the field and leave it empty):
      </Typography>
      <Box maxWidth={400}>
        <Formik
          initialValues={{ requiredField: "" }}
          validationSchema={Yup.object({
            requiredField: Yup.string().required("This field is required"),
          })}
          onSubmit={() => {}}
        >
          <Form>
            <FormTextField
              label="Required Field"
              fieldName="requiredField"
              required
            />
          </Form>
        </Formik>
      </Box>

      <Divider />

      <Typography variant="subtitle2">
        With emptyOnChange (for Autocomplete integration):
      </Typography>
      <Box maxWidth={400}>
        <Formik initialValues={{ autocompleteField: "" }} onSubmit={() => {}}>
          <Form>
            <FormTextField
              label="Autocomplete Field"
              fieldName="autocompleteField"
              emptyOnChange
              helperText="This field prevents onChange from being triggered"
            />
          </Form>
        </Formik>
      </Box>
    </Box>
  );
};

export default FormTextFieldDemo;
